import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=5518b1cd"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5518b1cd')) {
      api.createRecord('5518b1cd', component.options)
    } else {
      api.reload('5518b1cd', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=5518b1cd", function () {
      api.rerender('5518b1cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/posts/components/planner/calendar/Main.vue"
export default component.exports